import ProfileSetting from '@/Component/Profile/ProfileSetting';
import PersonalInformation from '@/Component/Profile/ProfileSetting/PersonalInformation.tsx';

const ProfileSettingPage = () => {
    return (
        <ProfileSetting activeTab="profile-settings">
            <PersonalInformation />
        </ProfileSetting>
    );
}

export default ProfileSettingPage;
